module.exports = __webpack_public_path__ + "static/media/cinema.b6864e9c.png";